// extracted by mini-css-extract-plugin
export var fullHeightState = "_3m-7";
export var headerCell = "_3m-1";
export var loadingStateCell = "_3m-4";
export var rowWrapper = "_3m-3";
export var standaloneTable = "_3m-8";
export var standaloneTableWithBodyFill = "_3m-9";
export var stateCell = "_3m-5";
export var table = "_3m-0";
export var tableBodyFiller = "_3m-6";
export var white = "_3m-2";